import React, { HTMLAttributes } from "react";
import { makeStyles, createStyles, Theme, useTheme } from "@material-ui/core/styles";
import PageSection from "components/layout/PageSection";
import background from "assets/images/homePage/bannerSection/BannerSectionBackground.jpg";
import mobileBackGround from "assets/images/homePage/bannerSection/BannerSectionBackgroundMobile.jpg";
import accoladeImg from "assets/images/homePage/bannerSection/ign_badge.png";
import imageSizes from "imageSizes";
import calculateAspectRatioVwHeight from "utils/calculateAspectRatioVwHeight";
import DefaultAosAnimation from "components/aos/DefaultAosAnimation";
import Rotate from "components/rotate/Rotate";
import Scribble from "components/scribble/Scribble";
import BannerVideo from "./components/BannerVideo";
import BuyNowWidget from "./components/BuyNowWidget";
import clsx from "clsx";
import { useMediaQuery } from "@material-ui/core";
import Spacer from "components/Spacer";
import { layoutConsts } from "theme";

const useStyles = makeStyles((theme: Theme) => {
    return createStyles({
        root: {
            position: "relative",
            backgroundColor: "#4c2166",
        },
        backgroundContainer: {
            backgroundImage: `url(${background})`,
            backgroundPosition: "center",
            backgroundSize: "cover",
            minHeight: calculateAspectRatioVwHeight(imageSizes.homePage.buyNowSection.background),
            [theme.breakpoints.down("sm")]: {
                backgroundImage: `url(${mobileBackGround})`,
                minHeight: calculateAspectRatioVwHeight(
                    imageSizes.homePage.buyNowSection.mobileBackground
                ),
            },
        },
        textBoxContainer: {
            flex: "1",
            display: "flex",
            alignItems: "center",
            [theme.breakpoints.down("sm")]: {
                justifyContent: "center",
                alignItems: "flex-start",
                marginBottom: "-30vw",
            },
            [theme.breakpoints.down("xs")]: {
                padding: theme.spacing(1),
                marginBottom: "-36vw",
            },
        },
        videoScribbleContainer: {
            top: "-10%",
            left: "-12%",
            height: "110%",
            width: "110%",
        },
        videoContainer: { position: "relative" },
        mobileTextBoxContainer: {
            zIndex: 100,
        },
        accoladeContainer: {
            position: "absolute",
            left: 0,
            bottom: 0,
            display: "flex",
            alignItems: "center",
            padding: "2vw",
            "& img": {
                width: "10.5vw",
                minWidth: 150,
                [theme.breakpoints.down("xs")]: {
                    minWidth: 100,
                },
            },
        },
    });
});

interface IProps extends HTMLAttributes<HTMLDivElement> {}

export default function BannerSection(props: IProps) {
    const classes = useStyles();
    const { className, ...rest } = props;

    const theme = useTheme();
    const smScreen = useMediaQuery(theme.breakpoints.down("sm"));
    const xsScreen = useMediaQuery(theme.breakpoints.down("xs"));

    const videoFlexSize = 9;

    const textBox = (
        <div style={{ flex: "1", maxWidth: 750 }}>
            <DefaultAosAnimation order={1} style={{ flex: "1" }}>
                <Rotate amount={-2}>
                    <Scribble
                        variant="v3"
                        classes={{
                            scribbleContainer: classes.videoScribbleContainer,
                        }}
                    >
                        <BannerVideo className={classes.videoContainer} />
                    </Scribble>
                </Rotate>
                <Rotate amount={-2}>
                    <BuyNowWidget />
                </Rotate>
            </DefaultAosAnimation>
        </div>
    );

    return (
        <div className={clsx(className, classes.root)} {...rest}>
            {smScreen ? (
                <PageSection classes={{ skewedSectionRoot: classes.mobileTextBoxContainer }} skewed>
                    <div style={{ flex: "1" }}>
                        <Spacer size={xsScreen ? 1 : 4} />
                        <div className={classes.textBoxContainer}>
                            <div
                                style={{
                                    flex: "1",
                                    display: "flex",
                                    justifyContent: "center",
                                }}
                            >
                                {textBox}
                            </div>
                        </div>
                    </div>
                </PageSection>
            ) : null}
            <PageSection
                maxWidth={layoutConsts.siteContentMaxWidth + 500}
                classes={{ skewedSectionRoot: classes.backgroundContainer }}
                skewed
            >
                {smScreen ? null : (
                    <div className={classes.textBoxContainer}>
                        <div style={{ flex: videoFlexSize }}></div>

                        <div style={{ flex: "1" }}></div>
                        <div
                            style={{
                                flex: videoFlexSize,
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            {textBox}
                        </div>
                    </div>
                )}
            </PageSection>
            <div className={classes.accoladeContainer}>
                <img src={accoladeImg} />
            </div>
        </div>
    );
}
